module.exports = __webpack_public_path__ + "img/medal.31e4f106.svg";